import { Suspense } from 'react';
import { useSelector } from 'react-redux';

import { useTranslator } from 'utils/translator';
import { getDialog } from 'store/selectors';
import Loader from 'components/loader';

import dialogs from './config';

const Dialogs = () => {
  const { t } = useTranslator();
  const dialogsState = useSelector(getDialog);

  const openDialogs = Object.entries(dialogsState).filter(([, isOpen]) => isOpen);

  return (
    <>
      {openDialogs.map(([name, isOpenedDialog]) => {
        const Dialog = dialogs[name];

        return (
          <Suspense key={name} fallback={<Loader />}>
            <Dialog isOpen={isOpenedDialog} t={t} />
          </Suspense>
        );
      })}
    </>
  );
};

export default Dialogs;
